import dynamic from 'next/dynamic';
import TermOfUseV from '@lib/view/components/terms-of-use-page';
import { GetServerSideProps, NextPage } from 'next';

const Layout = dynamic(import('@layout/home'));

const TermOfUseVM: NextPage<{}> = () => {
    return (
        <Layout title="T&C & Refund Policy">
            <TermOfUseV />
        </Layout>
    );
};

export default TermOfUseVM;

export const getServerSideProps: GetServerSideProps = async (): Promise<{
    props: { title: string };
}> => {
    return {
        props: {
            title: 'T&C & Refund Policy',
        },
    };
};
